'use client';

import { APIResponse } from '../types/api';
import { BrokerInfo } from '../types/broker';
import { masterDataEndpoints, masterDataFetcher } from './fetchers';

export async function broker() {
  try {
    const response = await masterDataFetcher.get<APIResponse<BrokerInfo>>(
      masterDataEndpoints.getBrokerConfig(
        getBrokerFromHostName(),
        'intraday',
        'Config'
      )
    );
    return response?.data?.data;
  } catch (e: any) {
    throw e?.response?.data;
  }
}

const aliasMap = new Map([
  ['daysprint', 'almondz'],
  ['almondz', 'almondz'],
  ['webapp', 'paper_trade'],
  ['intraday', 'paper_trade'],
  ['localhost', 'paper_trade'],
  ['intraedge', 'fivepaisa'],
  ['5paisa', 'fivepaisa'],
  ['anandrathi', 'anand_rathi'],
  ['anandrathi-intraday', 'anand_rathi'],
  ['symphony-intraday', 'symphony'],
  ['mandotary-intraday', 'mandot'],
  ['demo-intraday', 'demo'],
  ['ultraday', 'axis'],
  ['axis-intraday', 'axis'],
  ['lkp-intraday', 'lkp'],
]);

export const getBrokerFromHostName = () => {
  const separationWith: string =
    process.env.NEXT_PUBLIC_DOMAIN_SEPARATION || '.';
  const brandName =
    typeof window !== 'undefined'
      ? window.location.host?.split(separationWith)?.[0]?.toLowerCase()
      : '';
  return aliasMap.get(brandName) ?? brandName;
};
